import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { AdminCommunicationsPage } from "@/components/pages/AdminCommunicationsPage";

export const Route = createFileRoute("/admin/communications")({
  component: AdminCommunications,
});

function AdminCommunications() {
  return (
    <AppLayout>
      <AdminCommunicationsPage />
    </AppLayout>
  );
}
